import React from 'react';
import HeaderOnlyPage from '../components/layouts/HeaderOnlyPage';
import Footer from '../components/layouts/Footer';
import styles from './MainImagePage.module.scss';

// ヒーローイメージのリスト(public内に配置)
const mainimages = [
  'img_hero_01.jpg',
  'img_hero_02.jpg',
  'img_hero_03.jpg',
  'img_hero_04.jpg',
  'img_hero_05.jpg',
  'img_hero_06.jpg',
  'img_hero_07.jpg',
  'img_hero_08.jpg',
  'img_hero_09.jpg',
  'img_hero_10.jpg',
  'img_hero_11.jpg',
  'img_hero_12.jpg',
  'img_hero_13.jpg',
  'img_hero_14.jpg',
  'img_hero_15.jpg',
  'img_hero_16.jpg',
  'img_hero_17.jpg',
  'img_hero_18.jpg',
  'img_hero_19.jpg',
  'img_hero_20.jpg',
  'img_hero_21.jpg',
  'img_hero_22.jpg',
  'img_hero_23.jpg',
  'img_hero_24.jpg',
  'img_hero_25.jpg',
  'img_hero_26.jpg',
  'img_hero_27.jpg',
  'img_hero_28.jpg',
  'img_hero_29.jpg',
  'img_hero_30.jpg',
];

const MainImagePage: React.FC = () => {
  // 右クリック防止対応
  document.oncontextmenu = () => false;
  return (
    <div className={styles.main}>
      <HeaderOnlyPage title='ホームページ制作 メイン画像カタログ' />
      <main className={styles.mainimage}>
        <p className={styles.mainimage__notes}>
          <span className={styles.mainimage__paragraph}>以下はトップページに掲載される画像サンプルです。 </span>
          <span className={styles.mainimage__paragraph}>
            1枚お選びいただいた上、
            <a
              href='https://docs.google.com/forms/d/e/1FAIpQLSd1w8vf8zYb2zzduMjCJ15VJyEE723aCc1hqzYWjssWonil6Q/viewform'
              className={styles.mainimage__link}
              target='_blank'
              rel='noreferrer'
            >
              こちら
            </a>
            のフォームの「トップページのメイン画像」欄に番号をご記入ください。
          </span>
        </p>
        <ul className={styles.mainimage__list}>
          {mainimages.map((mainimage, index) => {
            const imgNum = `0${index + 1}`.slice(-2);
            return (
              <li className={styles.mainimage__item} key={mainimage}>
                <p className={styles.mainimage__num}>{imgNum}</p>
                <img
                  src={`${process.env.PUBLIC_URL}/common/img/hero/${mainimage}`}
                  alt={`メイン画像${imgNum}`}
                  className={styles.mainimage__image}
                />
              </li>
            );
          })}
        </ul>
      </main>
      <Footer />
    </div>
  );
};

export default MainImagePage;
